import { actions } from './services';

const getInitialState = () => {
  return {
    display: false,
    mountOptions: {
      action: 'NONE',
      payload: {}
    },
    vetClients: {},
    isLoading: false,
    allowedCountriesList: null
  };
};

//by default => initial state
const state = getInitialState();

const mutations = {
  deleteClient: (state, { clientId, isPraxis }) => {
    const clientGroup = isPraxis === true ? 'employees' : 'clients';
    state.vetClients = {
      ...state.vetClients,
      [clientGroup]: Object.keys(state.vetClients[clientGroup]).reduce(
        (acc, key) => {
          if (parseInt(key) !== parseInt(clientId)) {
            acc = {
              ...acc,
              [key]: state.vetClients[clientGroup][key]
            };
          }

          return acc;
        },
        {}
      )
    };
  },
  updateVetClient: (state, payload) => {
    const clientGroup = payload.isPraxis === true ? 'employees' : 'clients';
    state.vetClients = {
      ...state.vetClients,
      [clientGroup]: {
        ...state.vetClients[clientGroup],
        [payload.id]: payload.data
      }
    };
  },
  displayAddressBook: (state, payload = {}) => {
    if (window) {
      window.scrollTo(0, 0);
    }
    Object.assign(state, { ...state, ...payload, display: !!!state.display });
    // apply overflow:hidden to the body when addressbook opens to prevent scrollbars
    document.body.style.overflow = state.display ? 'hidden' : '';
  },
  closeAddressBook: state => {
    state.display = false;
    document.body.style.overflow = '';
  },
  setVetClients: (state, vetClients) => {
    state.vetClients = vetClients;
    state.isLoading = !!!state.isLoading;
  },
  load: state => {
    state.isLoading = !!!state.isLoading;
  },
  resetState: state => {
    Object.assign(state, getInitialState());
  },
  resetLoaders: state => {
    document.body.style.overflow = state.display ? 'hidden' : '';
    state.mountOptions = {
      action: 'NONE',
      payload: {}
    };
  },
  storeAllowedCountries: (state, payload) => {
    state.allowedCountriesList = payload.countries;
  }
};

const getters = {
  displayAddressBook: state => state.display,
  getVetClients: state => state.vetClients,
  isLoading: state => state.isLoading
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
